import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";

export const getAdminDashboardCount = createAsyncThunk(
    "admin/getAdminDashboardCount",
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                apiEndpoints.adminDashboardCount,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const toggleUserActive = createAsyncThunk(
    "admin/toggleUserActive",
    async (payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.post(
                apiEndpoints.toggleUserActive, payload,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getadminWeekOverview = createAsyncThunk(
    "admin/getadminWeekOverview",
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                apiEndpoints.adminWeekOverview,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getadminSalesPersonWeekOverview = createAsyncThunk(
    "admin/getadminSalesPersonWeekOverview",
    async (salesId, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                apiEndpoints.adminSalesPersonWeekOverview.replace("{user_pk}",salesId),
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getAllSalesOrders = createAsyncThunk(
    "orders/getAllSalesOrders",
    async (salesId, { rejectWithValue }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.get(
                apiEndpoints.getAllSalesOrders.replace("{user_pk}",salesId),
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getUsersList = createAsyncThunk(
    "admin/getUsersList",
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                apiEndpoints.usersList,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

// ✅ Slice definition
const adminSlice = createSlice({
    name: "admin",
    initialState: {
        adminLoading: false,
        success: false,
        adminFetchError: null,
        adminDashboardCountResponse: {},
        adminWeekOverviewResponse: {},
        adminSalesPersonWeekOverviewResponse: {},
        salesOrdersData: {},
        usersListResponse: {},
        toggleUserResponse: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAdminDashboardCount.pending, (state) => {
                state.adminLoading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getAdminDashboardCount.fulfilled, (state, action) => {
                state.adminLoading = false;
                state.success = true;
                state.adminDashboardCountResponse = action.payload;
            })
            .addCase(getAdminDashboardCount.rejected, (state, action) => {
                state.adminLoading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getadminWeekOverview.pending, (state) => {
                state.adminLoading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getadminWeekOverview.fulfilled, (state, action) => {
                state.adminLoading = false;
                state.success = true;
                state.adminWeekOverviewResponse = action.payload;
            })
            .addCase(getadminWeekOverview.rejected, (state, action) => {
                state.adminLoading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getadminSalesPersonWeekOverview.pending, (state) => {
                state.adminLoading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getadminSalesPersonWeekOverview.fulfilled, (state, action) => {
                state.adminLoading = false;
                state.success = true;
                state.adminSalesPersonWeekOverviewResponse = action.payload;
            })
            .addCase(getadminSalesPersonWeekOverview.rejected, (state, action) => {
                state.adminLoading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getUsersList.pending, (state) => {
                state.adminLoading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getUsersList.fulfilled, (state, action) => {
                state.adminLoading = false;
                state.success = true;
                state.usersListResponse = action.payload;
            })
            .addCase(getUsersList.rejected, (state, action) => {
                state.adminLoading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(toggleUserActive.pending, (state) => {
                state.adminLoading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(toggleUserActive.fulfilled, (state, action) => {
                state.adminLoading = false;
                state.success = true;
                state.toggleUserResponse = action.payload;
            })
            .addCase(toggleUserActive.rejected, (state, action) => {
                state.adminLoading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getAllSalesOrders.pending, (state) => {
                state.adminLoading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getAllSalesOrders.fulfilled, (state, action) => {
                state.adminLoading = false;
                state.success = true;
                state.salesOrdersData = action.payload;
            })
            .addCase(getAllSalesOrders.rejected, (state, action) => {
                state.adminLoading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            });
    },
});

// ✅ Export actions and reducer

export default adminSlice.reducer;